/**
 * 状态标签 — 三通道冗余（图标 + 文字 + 颜色）的唯一实现入口。
 *
 * 03-UIUX.md §3.4 明确禁止：只有色点无文字、整行背景染色、颜色作为唯一区分手段。
 * 因此本组件**不提供** `iconOnly` 或 `colorOnly` 之类的开关 —— 少一个开关，
 * 就少一处能违反 WCAG 1.4.1 的地方。
 */
import type { CSSProperties } from 'react';
import { Icon } from '../icons/Icon';
import { cssVar, ICON_SIZE, statusOf } from '../tokens';
import type { AnyStatus } from '../tokens';

export interface StatusBadgeProps {
  readonly status: AnyStatus;
  /** 附加说明，进 title（如 status_reason） */
  readonly reason?: string | null;
}

export function StatusBadge({ status, reason }: StatusBadgeProps) {
  const descriptor = statusOf(status);
  const style = { '--st': cssVar(descriptor.token) } as CSSProperties;

  return (
    <span className="status-badge" style={style} title={reason ?? undefined}>
      <Icon name={descriptor.icon} size={ICON_SIZE.badge} />
      {descriptor.label}
    </span>
  );
}

/**
 * void 的第四通道：授权码本身加删除线（06 §3 备注）。
 * 返回类名而非直接改 badge —— 失效的是「那条记录」，不是「那个标签」。
 */
export function codeCellClassName(status: AnyStatus): string | undefined {
  return statusOf(status).extra === 'line-through' ? 'code-cell--void' : undefined;
}
